<!--@if (uiContracts?.length) {-->
<!-- <h1>CONTRACTS</h1> -->
<div class="surface-card border-round-lg p-4">
  <div class="flex align-items-center justify-content-between mb-3">
    <div class="text-900 font-medium text-xl">{{ header }}
      @if (showTooltip) {
        <!--        <i class="pi pi-info-circle"  [pTooltip]="tooltipText"></i>-->
        <div
          (mouseenter)="op.show($event)"
          (mouseleave)="op.hide()"
          style="display: inline-block; cursor: pointer;">
          <i class="pi pi-info-circle"></i>
        </div>

        <p-overlayPanel #op appendTo="body"
                        [style]="{
    'background-color': 'black',
    'color': 'white',
    'overflow': 'hidden',
    'margin-left': '12px',
  }">
          <ng-template pTemplate="content">
            <div class="w-18rem">
              {{ tooltipText }}
            </div>
          </ng-template>
        </p-overlayPanel>


      }
    </div>
    <div *ngIf="!showUnmanaged" (click)="showAllContracts()" class="cursor-pointer">
      Alle anzeigen
    </div>
  </div>

  @if (initialized && contractsRuntime && contractsRuntime?.contracts?.length) {
    <p-table [value]="uiContracts"
             [scrollable]="true" scrollHeight="28rem"
             [breakpoint]="'960px'" [tableStyle]="{'min-width': '12rem'}"
             tableStyleClass="fixed-table-layout">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>Gesellschaft</th>
          <th>Typ</th>
          <th>Vertragsnummer</th>
          <th>Beginn</th>
          <!--        <th>Ende</th>-->
          <!--        <th>Status</th>-->
          <th>Beitrag</th>
          <!--          <th></th>-->
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-contract let-columns="columns">
        <tr (click)="showContract(contract)" class="cursor-pointer">
          <td>  @if (contract.insuranceCompany?.imageUrl) {
            <img style="object-fit: contain;" class="w-6rem" pTooltip="{{contract.insuranceCompany?.name }}"
                 [src]="contract.insuranceCompany?.imageUrl" [alt]="contract.insuranceCompany?.name"/>
          } @else {
            <span class="w-5rem">{{ contract.insuranceCompany?.name }}</span>
          }
          </td>
          <td><span class="">{{ contract.insuranceType?.name }}</span></td>
          <td><span class="p-column-title">Versicherungsscheinnummer</span>@if (contract.notFullyManaged) {
            <i class="pi pi-exclamation-triangle text-red-500"></i>
          } {{ contract.insuranceIdentNumber }}
          </td>
          <td>
            <div class="flex flex-column gap-2">
              <!--            Ticket DWK1000000764-->
              @if((contract.startDate || contract.endDate) && (contract.startDate !== '1900-01-01' && contract.endDate !== '1900-01-01')){
                <span>{{ contract.startDate | date:'dd.MM.yyyy' }}</span>
                <span *ngIf="contract.endDate" class="text-red-500">{{ contract.endDate | date:'dd.MM.yyyy' }}</span>
              }@else{
                    -
              }
            </div>
          </td>
          <!--        <td><span class="p-column-title">Ende</span>{{contract.endDate}}</td>-->
          <!--        <td><span class="p-column-title">Status</span><p-tag icon="pi pi-circle-fill pr-1" styleClass="px-2" [rounded]="true" severity="success" [value]="contract.contractStatusText"></p-tag></td>-->
          <td><span class="font-semibold">
            @if (contract?.freePayment) {
              Beitragsfrei
            } @else  if (contract.cost?.formattedAmount) {
              {{ contract.cost?.formattedAmount }} {{ contract.paymentFrequencyText }}
            } @else {
              -
            }


            <br/> <span
            class=""></span></span></td>
          <!--          <td class="text-center">-->
          <!--            <p-button icon="pi pi-eye" (onClick)="showContract(contract)"></p-button>-->
          <!--          </td>-->
        </tr>
      </ng-template>

    </p-table>
  } @else {
    <div class="flex flex-column gap-2 align-items-center my-5">
      <i class="pi pi-search text-8xl text-200"></i>
      <h4 class="text-center">Hier werden deine aktiven Verträge angezeigt.</h4>
      <span class="text-color-secondary text-center">
          Derzeit sind hier keine aktiven Verträge verfügbar, die angezeigt werden können.
          </span>
    </div>
  }
</div>


<!--}-->
